import { Grid, styled } from '@mui/material';
import SkuDelist from '../sku-delist/sku-delist';

const StyledGrid = styled(Grid)`
  height: 100%;
  width: 100%;
`;

export default function Delist() {
  return (
    <StyledGrid>
      <SkuDelist />
    </StyledGrid>
  );
}
